import { css } from 'styled-components';

import type { GetAllPropTypes } from 'quarks/quarkUtils/getAllProps';
import { getPropsFromObjectCSS } from 'quarks/quarkUtils/getAllProps';
import basicCSS from 'quarks/styleProps/basic';
import flexCSS from 'quarks/styleProps/flex';
import textCSS from 'quarks/styleProps/text';

const textStyles = {
  ...textCSS,
  ...basicCSS,
  ...flexCSS,
};

export type TextProps = GetAllPropTypes<typeof textStyles>;
export const text = css<TextProps>`
  ${props => getPropsFromObjectCSS(props, textStyles)}
`;
